export const isPortfolioIdRequiredError = (error) => {
  const errorText = String(error?.error || error?.message || "").toLowerCase();
  return errorText.includes("portfolioid");
};

